"use script";

angular.module("core")
.constant("PRODUCT_ACQUISITION_METHOD", {
    "DELIVERY": "delivery",
    "PICKUP": "pickup"
});



//////////////////
// WEBPACK FOOTER
// ./core/partnership-model/partnership.constant.js
// module id = 395
// module chunks = 0